import type { ReactElement } from "react";
import React from "react";
import Modal from "~/components/modal.tsx";
import { usePreventUnloadWarningCallback } from "~/context/before-unload.tsx";
import { useWebsiteUrl } from "~/context/website-url.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type ConfirmExitModalProps = {
	readonly show: boolean;
	readonly onCancel: () => void;
};

function ConfirmExitModal({
	show,
	onCancel,
}: ConfirmExitModalProps): ReactElement {
	const websiteUrl = useWebsiteUrl("/");
	const preventUnloadWarning = usePreventUnloadWarningCallback();
	const t = useTranslator();
	return (
		<Modal show={show} title={t("WARNING!")} onClose={onCancel}>
			<Modal.Text>{t("Are you sure you want to exit?")}</Modal.Text>
			<Modal.Actions
				actions={[
					{ text: t("Cancel"), onClick: onCancel, type: "ghost" },
					{
						text: t("Yes"),
						href: websiteUrl,
						target: "self",
						onMouseDown: preventUnloadWarning,
					},
				]}
			/>
		</Modal>
	);
}

export default ConfirmExitModal;
